import i18n, { EN } from '@/assets/js/i18n';
import { formatterColTransferUnit } from '@/utils/enterprise';

/**
 * 股票报价相关的通用方法
 */
export function useStockVO() {
	const formattedValue = (value, format = null) => {
		if (value === null || value === undefined) return '- -';
		if (typeof value !== 'number') return '- -';
		if (isNaN(value)) return '- -';
		return format ? format(value) : value;
	};

	const stockColTransferUnit = (amount, split = false) => {
		if (typeof amount !== 'number') return '- -';
		return formatterColTransferUnit(amount, split);
	};

	const ttmFilter = (amount, $t) => {
		if (amount < 0) {
			return i18n.t('enterprise.loss');
		} else {
			return stockColTransferUnit(amount);
		}
	};

	const getVolumeAmountAndUnit = (Volume, locale) => {
		return {
			amount: locale === EN ? Volume * 100 : Volume,
			unit: locale === EN ? '' : '手'
		};
	};

	const computedVolume = (data, locale) => {
		const { turnoverVolume } = data;
		const { amount, unit } = getVolumeAmountAndUnit(turnoverVolume, locale);
		const value = stockColTransferUnit(amount);
		return `${value}${unit}`;
	};

	const computedClosePrice = data => {
		let res = stockColTransferUnit(data, true);
		return `${res[0]}<span style="font-size: 0.2rem;">${res[1]}</span>`;
	};

	// Methods
	const divideByHundred = value => {
		if (typeof value !== 'number') {
			return '-';
		}
		return value.toFixed(2);
	};

	const appendPlusIfPositive = value => {
		if (typeof value !== 'number') {
			return '-';
		}
		return value > 0 ? '+' + value.toString() : value;
	};

	const formatChangePct = value => {
		if (typeof value !== 'number') {
			return '-';
		}
		let _value = value.toFixed(2);
		_value = _value > 0 ? '+' + _value.toString() : _value;
		return `${_value}%`;
	};

	const computedBlyVolume = data => {
		const { turnoverVolume } = data;
		const { amount, unit } = getVolumeAmountAndUnit(turnoverVolume);
		if (typeof amount !== 'number') return 0;
		if (i18n.locale === EN) return stockColTransferUnit(amount);

		const value = amount / 100;
		return `${value}${unit}`;
	};

	// 轮询实时查询方法
	let pollingTimeoutId = null;
	const startPolling = (queryTask, interval = 60000) => {
		if (!queryTask) return;
		stopPolling();
		const executeFetch = async () => {
			await queryTask();
			pollingTimeoutId = setTimeout(executeFetch, interval);
		};
		executeFetch();
	};

	const stopPolling = () => {
		console.log('______________ loop:', pollingTimeoutId);
		if (pollingTimeoutId) {
			clearTimeout(pollingTimeoutId);
			pollingTimeoutId = null;
		}
	};

	return {
		formattedValue,
		stockColTransferUnit,
		ttmFilter,
		getVolumeAmountAndUnit,
		computedVolume,
		computedClosePrice,
		divideByHundred,
		appendPlusIfPositive,
		formatChangePct,
		computedBlyVolume,
		startPolling,
		stopPolling
	};
}
